import {
  FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_REQUEST,
  FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_SUCCESS,
  FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_FALUIRE,
} from './loadLoggedInUserPermissionTypes'

const initialState = {
  loading: false,
  loggedInUserPermissions: [],
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_SUCCESS : return {
      ...state,
      loggedInUserPermissions: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_LOGGED_IN_USER_PERMISSIONS_FALUIRE : return {
      ...state,
      loading: false,
      loggedInUserPermissions: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
